module.exports = __webpack_public_path__ + "static/media/loc2_img13.20c9bad6.jpg";